import { useState } from "react";

export function useSubmitModal(
  SubmitModalCreator: (
    closeSubmitModal: CallableFunction
  ) => JSX.Element | undefined
): [JSX.Element | undefined, () => void] {
  const [isSubmitModalOpen, setIsSubmitModalOpen] = useState(false);

  const closeSubmitModal = () => {
    setIsSubmitModalOpen(false);
  };

  let SubmitModal = isSubmitModalOpen
    ? SubmitModalCreator(closeSubmitModal)
    : undefined;

  return [SubmitModal, () => setIsSubmitModalOpen(true)];
}

export function useSubmitModalWithParameter<T>(
  SubmitModalCreator: (
    p: T,
    closeSubmitModal: CallableFunction
  ) => JSX.Element | undefined
): [JSX.Element | undefined, (parameter: T) => void] {
  const [isSubmitModalOpen, setIsSubmitModalOpen] = useState(false);
  const [parameter, setParameter] = useState<T>();

  const closeSubmitModal = () => {
    setIsSubmitModalOpen(false);
  };

  let submit =
    isSubmitModalOpen && parameter !== undefined
      ? SubmitModalCreator(parameter, closeSubmitModal)
      : undefined;

  return [
    submit,
    (parameter: T) => {
      setParameter(parameter);
      setIsSubmitModalOpen(true);
    },
  ];
}
